export const workoutModelMixin = {
  data() {
    return {
      workoutModelObj: {
        circuits: [],
        description: null,
        exerciseDifficulty: null,
        label: '',
        mediaAssets: null,
        muscleGroup: null,
        muscleGroups: [],
        org_id: null,
        timeToComplete: null,
        trainer_id: '0',
        type: 'work',
        user_id: '0',
      },
    };
  },
  methods: {
    getWorkoutModel() {
      return this.workoutModelObj;
    },
  },
};
